/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GuidelineService } from '../services/guideline.service';
import { NgIf } from '@angular/common';
import { RespondComponent } from '../respond/respond.component';
import { FuqComponent } from '../fuq/fuq.component';
import { Subject, takeUntil } from 'rxjs';
import { FUQ_ERROR_MSG } from '../constants';

@Component({
  selector: 'app-conversation',
  standalone: true,
  imports: [NgIf, RespondComponent, FuqComponent],
  templateUrl: './conversation.component.html',
  styleUrl: './conversation.component.scss'
})
export class ConversationComponent implements AfterViewChecked {
  @Input('userQuestion') userQuestion!: string;
  botResponse!: any
  botError: any;
  FUQResponse!: any;
  FUQError: any
  batchPreviewResponse: any;
  batchPreviewError: any;
  hideFuq : boolean = false;
  @Output() selectedCitation = new EventEmitter<any>();
  @Output() fuqQuestionForFollowup = new EventEmitter<any>();
  enableScroll = false;
  @ViewChild('scrollToHere') scrollToHere!: ElementRef;
  @ViewChild(RespondComponent) respondComp!: RespondComponent;
  @Output() isPreviousCitationHighlighted = new EventEmitter<boolean>();
  private cancelRequest$ = new Subject<void>();
  constructor(public guidelineServ: GuidelineService) { }

  ngOnInit() {
    this.enableScroll = false;
    this.guidelineServ.generateBotResponse(this.userQuestion, {}, this.guidelineServ.getSessionId())
      .pipe(takeUntil(this.cancelRequest$)).subscribe({
        next: (response: any) => {
          if (response !== undefined) {
            this.guidelineServ.setSessionId(response.session_id);
            this.botResponse = response;
            this.guidelineServ.setDisableFuqPanels(false);
            this.enableScroll = true;
            // if (response)
            //   this.constructBatchPreviewRequest(response.inline_citations)
          }
        },
        error: (error: any) => {
          this.botError = error;
          this.guidelineServ.setDisableFuqPanels(false);
          this.enableScroll = true;
        }
      })

    this.guidelineServ.generateFUQResponse(this.userQuestion, {}, this.guidelineServ.getSessionId())
      .pipe(takeUntil(this.cancelRequest$)).subscribe({
        next: (response: any) => {
          if (response !== undefined) {
            this.FUQResponse = response;
            this.enableScroll = true;
          }
        },
        error: (error: any) => {
          this.FUQError = FUQ_ERROR_MSG
          this.enableScroll = true;
        }
      })
  }
  ngAfterViewChecked() {
    if (this.enableScroll) {
      this.scrollToLatestText();
    }
  }
  scrollToLatestText() {
    const beforeScrollY = window.scrollY; // Get initial scroll position
    this.scrollToHere?.nativeElement.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      const afterScrollY = window.scrollY; // Get new scroll position
      if (beforeScrollY === afterScrollY) {
        this.enableScroll = false;
      }
    }, 500); // Wait for smooth scrolling to complete
  }
  // constructBatchPreviewRequest(inline_citations: any) {
  //   let batchContentRequest = []
  //   for (const key in inline_citations) {
  //     batchContentRequest.push(inline_citations[key]?.[0])
  //   }
  //   batchContentRequest = batchContentRequest.map(({ vais_content, relevance_score, ...rest }: any, index: number) => ({
  //     ...rest,
  //     relevance_score: relevance_score.toString(),
  //     citation_number: index + 1
  //   }));
  //   this.guidelineServ.batchPreviewContent(batchContentRequest).pipe(takeUntil(this.cancelRequest$)).subscribe({
  //     next: (response: any) => {
  //       if (response !== undefined) {
  //         this.batchPreviewResponse = response;
  //       }
  //     },
  //     error: (error: any) => {
  //       this.batchPreviewError = error;
  //     }
  //   })
  // }

  onSelectedCitation(citationContent: any) {
    this.selectedCitation.emit(citationContent);
  }

  onFuqQuestionClick(question: any) {
    this.fuqQuestionForFollowup.emit(question);
  }

  clearCitationHighlight() {
    this.respondComp.removeHighlightClass();
  }

  isCitationHighlighted(val: any) {
    this.isPreviousCitationHighlighted.emit(val);
  }
  cancelRequest() {
    this.cancelRequest$.next();  //  Cancels the request
  }

  hideFuqs(hideFuq: any) {
    this.hideFuq = hideFuq;
  }
  ngOnDestroy() {
    this.guidelineServ.setSessionId(""); // empty the session_id when conversation refresh 
    this.cancelRequest(); // prevent memory leaks
    this.cancelRequest$.complete();
  }

}
